export default {
  methods: {
    formatTable(table, field, type, rolloverArray=null) {

      if (!table) return [];

      return Object.entries(table).map(([name, category]) => {
        if (!category) return {};

        let data = category.data ? category.data : category;
        let rollover = rolloverArray ? rolloverArray[name] : data.rollover;
        delete data.rollover;

        const dates = Object.entries(data).reduce((acc, [key, val], index) => {
          let value = '';

          if (val[field]) {
            value = type ? val[field][type] : val[field];
          }

          if (field === 'variance') value = value + '%';
          return { ...acc, [key]: value };
        }, {});

        
        return {
          name,
          dates,
          rollover: rollover || 'No data found.',
        };
      });
    },
    formatChart(chart, field, type) {
      if (_.isEmpty(chart)) return {};

      return Object.entries(chart).map(([name, category]) => {
        let data = category.data ? category.data : category;
        let formattedData = Object.entries(data)
          .filter(([k, v]) => k !== 'rollover')
          .map(([key, val]) => (type ? val[field][type] : val[field]));
        return {
          data: {
            labels: Object.keys(data),
            series: Object.values(ret),
          },
          title: category.title,
        };
      });
    },
    formatMultipleChart(chart) {
      if (_.isEmpty(chart)) return {};

      return Object.entries(chart).map(([name, category]) => {
        let data = category.data ? category.data : category;
        let ret = {};

        for (let val of Object.values(data)) {
          for (let key in val) {
            if (!ret[key]) ret[key] = [];
            ret[key].push(val[key]);
          }
        }

        return {
          data: {
            labels: Object.keys(data),
            series: Object.values(ret),
          },
          title: category.title,
          score: category.score,
        };
      });
    },
    formatPieChart(charts) {
      if (_.isEmpty(charts)) return [];

      let newCharts = [];
      Object.entries(charts).map(([chart, categories]) =>
        categories.map((category, i) => {
          newCharts.push({
            type: chart,
            title: category.title,
            data: {
              series: category.data.map((item) => (typeof item.value === 'string' && item.value.includes('-')?0:item.value)),
            },
            options: {
              legendNames: category.data.map((item) => item.label),
              labelInterpolationSignFn: (val) =>
                chart === 'dollar'
                  ? '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  : val + '%',
              labelInterpolationSign: chart === 'dollar' ? '$' : '%',
            },
          });
        })
      );

      return newCharts;
    },
    getOptions(newOptions = {}) {
      let options = this.options || {};
      return {
        ...options,
        ...newOptions,
      };
    },
    formatTitleToClass(title) {
      let classString = title.replace(/[^\w\s]/gi, '').replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      }).replace(/\s+/g, '');
      return classString;
    },
    numberWithCommas(x) {
      if(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return x;
    }
  },
};
